var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-textarea',{attrs:{"id":_vm.id,"name":_vm.name,"state":_vm.state,"placeholder":_vm.placeholder || _vm.name,"size":"sm","rows":_vm.rows},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }